import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CustomDateFormat } from '../main/CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CommonFunction } from '../../app/main/CommonFunction';

@Component({
    selector: 'account-posting-template',
    template: require('./AccountPostingTemplate.html'),
    styles: [``]
})

export class AccountPostingTemplateComponent implements OnInit {

    static parameters = [UtilityService, HotkeysService, NgbModal, NgbModalConfig, HttpClient, CustomDateFormat, DatePipe, CommonFunction];
    
    @Input('PartyType') PartyType: any;
    @Input('Doc_No') Doc_No: any;
    @Input('Party_ID') Party_ID: any;
    @Input("dValue") dvalue: any;
    @Input("TransNo") TransNo: any;
    @Input("Doc_Date") Doc_Date: any;


    gridPayReceiptApi: any;
    paginationConf:any;
    gridPayReceiptColumnApi: any;
    PayReceiptList: any;
    PayReceiptColDef: any;
    rowSelectionSingle: string;
    unitInfo: any;
    d :any;
    defaultColDef:any;
    public hotkeyList: Hotkey[];
    public hotkeyListModal: Hotkey[];
    busy: Subscription;
    totalCredit: number;
    totalDebit: number;

    constructor(public utilityService: UtilityService, private hotkeysService: HotkeysService, private modalService: NgbModal, config: NgbModalConfig,private http: HttpClient,public customDateFormat: CustomDateFormat,public datePipe: DatePipe ,public commonFunction : CommonFunction) {
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
    }

    ngOnInit(): void {
        this.d = this.dvalue;
        //console.log('Account posting init! ====> ', this.d);
        this.rowSelectionSingle = "single";        
        this.paginationConf = true;
        this.PayReceiptList = [];
        this.initHotkeys();
        this.getAdjustmentDetails();
    }

    ngAfterViewInit() {
        this.paginationConf =true;
    }

    /* onPayReceiptGridReady(params){
        this.PayReceiptColDef = [
            { headerName: 'Doc Type', field: 'DocType_Code' },
            { headerName: 'Doc No', field: 'Doc_No' },            
            { headerName: 'Doc Date', field: 'Post_Date' },
            { headerName: 'Due Date', field: 'Post_Date' },
            { headerName: 'Over Days', field: 'OverDays', cellStyle: {'text-align': 'right'} },
            { headerName: 'Amount', field: 'Total_BillAmount', cellStyle: {'text-align': 'right'} },
            { headerName: 'Adjusted', field: 'adjustedAmount', cellStyle: {'text-align': 'right'} },
            { headerName: 'Discount', field: 'discountAmount', cellStyle: {'text-align': 'right'}},
        ];
       
        this.gridPayReceiptApi = params.api;
        this.gridPayReceiptColumnApi = params.columnApi;
        this.gridPayReceiptApi.sizeColumnsToFit();
        this.defaultColDef = {
            resizable: true,
            sortable : true,
        };
    } */

    initHotkeys() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }  
  
    public accountPostingDetails: any;
    public gridApiaccountPosting: any;
    public gridColumnApiaccountPosting: any;
    public accountPostingdetailscolumnDefs: any;

    accountPostingdetailsGridApi(params) {
        this.gridApiaccountPosting = params.api;
        this.gridColumnApiaccountPosting = params.columnApi;
        this.gridApiaccountPosting.sizeColumnsToFit();
    }

    getAdjustmentDetails() {
        /* var Data = {
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "Doc_No": this.Doc_No,
            "Party_ID": this.Party_ID,
            "PartyType": this.PartyType,
        }
      //   console.log("data", Data);
        this.busy = this.http.post('/api/vendors/GetPayReceiptAdjustmentDetails', Data)
            .subscribe(response => {
                this.PayReceiptList = response;
                if(this.PayReceiptList.length > 0){
                    setTimeout(() => {
                        this.gridPayReceiptApi.sizeColumnsToFit();
                        this.gridPayReceiptApi.getModel().getRow(0).setSelected(true);
                        this.gridPayReceiptApi.setFocusedCell(0, "Doc_No");
                    }, 200);
                }
            }) */

            var Data = {
                "Company_ID": this.unitInfo.Company_ID,
                "Unit_ID": this.unitInfo.Unit_ID,
                "FI_ID": this.Doc_No,
                "Party_ID": this.Party_ID,
                "PartyType": this.PartyType,
            }
            this.busy = this.http.post(`/api/${this.unitInfo.Company_Code}/products/getAccountPostingDetailsForLedger`, Data)
                .subscribe(response => {
                    // console.log("response of Account Posting", response);
                    this.accountPostingDetails = response;
                    if (this.accountPostingDetails) {
                        this.accountPostingdetailscolumnDefs = this.generateColumns2(this.accountPostingDetails);
                       // this.openaccountPostingPopup(this.accountpostingpopup);
                       this.calculateTotal();
                    }
                });
        
    }

    generateColumns2(data: any[]) {
        let columnDefinitions = [];

        data.map(object => {

            Object
                .keys(object)
                .map(key => {
                    let mappedColumn = {
                        headerName: key.toUpperCase(),
                        field: key,
                        cellStyle: key.toLowerCase() == 'debit' || key.toLowerCase() == 'credit' ? { 'textAlign': "right" } : { 'textAlign': "left" },
                        cellClassRules: {                    
                            "accounting-total-high-color": function(params) {
                                if(params.data.Account.toLowerCase() == "total"){
                                    return true;
                                }
                            }
                        },
                    }

                    columnDefinitions.push(mappedColumn);
                })
        })
        //Remove duplicate columns
        columnDefinitions = columnDefinitions.filter((column, index, self) =>
            index === self.findIndex((colAtIndex) => (
                colAtIndex.field === column.field
            ))
        )
        return columnDefinitions;
    }

    calculateTotal(){
        this.totalCredit = 0;
        this.totalDebit = 0;

        this.accountPostingDetails.forEach(
            item=>{
                if(item.Credit){
                    this.totalCredit += parseFloat(item.Credit);
                }
                if(item.Debit){
                    this.totalDebit += parseFloat(item.Debit);
                }
            }
        );

        const TotalRow={
           // AcCode:'SumTotal',
            Account:'Total',
            Debit: this.totalDebit.toFixed(2),
            Credit: this.totalDebit.toFixed(2),
        }

        this.accountPostingDetails.push(TotalRow);
    }
}